import { Injectable } from '@angular/core';

interface PreferenceValue {
	[key: string]: any;
}

@Injectable({
	providedIn: 'root',
})
export class PreferencesService {
	private localStorageKey = 'preferences';

	private loadPreferences(): PreferenceValue {
		let prefs: PreferenceValue = {};
		const storedPrefs = localStorage.getItem(this.localStorageKey);
		if (storedPrefs) {
			try {
				prefs = JSON.parse(storedPrefs);
			} catch (error) {
				console.warn('Failed to parse preferences from localStorage:', error);
			}
		}
		return prefs;
	}

	private writePreferencesToLocalStorage(prefs: PreferenceValue) {
		localStorage.setItem(this.localStorageKey, JSON.stringify(prefs));
	}

	public setPreference(preferences: PreferenceValue): void {
		const prefs = this.loadPreferences();
		Object.assign(prefs, preferences);
		this.writePreferencesToLocalStorage(prefs);
	}

	public getPreference<T = any>(pref: string): T | undefined {
		const prefs = this.loadPreferences();
		const value = prefs[pref];
		return value !== undefined ? (value as T) : undefined;
	}
}
